<template>
  <v-alert v-if="showBanner"
           type="warning"
           tile
           dense>
    <div>
      Your company only has {{ availableCredits | number }} {{ availableCredits | pluralize('email verification credit', false) }} remaining.
    </div>
    <div>
      <router-link :to="{name: 'admin.neverbounce.email_lists.index', query: {buy_credits: 1}}" class="text-decoration-underline font-weight-bold white--text">Buy more now</router-link>
      to ensure maximum email deliverability.
    </div>
  </v-alert>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'team',
      'emailCreditInfo',
    ]),
    showBanner() {
      if (this.emailCreditInfo && this.emailCreditInfo.loaded && this.team && this.team.email_verification_enabled && this.team.show_email_verification_low_credit_banner) {
        return this.availableCredits <= this.team.email_verification_low_credit_threshold;
      }
      return false;
    },
    availableCredits() {
      return this.emailCreditInfo.available_credits;
    },
  },
}
</script>
